exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-ylw[data-v-63ddf320] {\n  color: #D19E07;\n}\n.mg-right[data-v-63ddf320] {\n  margin-right: 10px;\n}\n", ""]);

// exports
